import api from './api';

export interface ChecklistItem {
  _id?: string;
  description: string;
  executionOrder: number;
  requireSignature: boolean;
  type: 'image_capture' | 'update_data' | 'update_equipment' | 'collect_signature' | 'simple_check' | 'value_input';
  value?: string;
  parentItemId?: string | null;
  isActive: boolean;
  createdAt?: string;
  updatedAt?: string;
}

export interface ChecklistTemplate {
  _id?: string;
  name: string;
  description?: string;
  serviceType: 'maintenance' | 'installation' | 'inspection' | 'repair' | 'other';
  items: ChecklistItem[];
  isActive: boolean;
  createdBy?: {
    _id: string;
    displayName: string;
    email: string;
  };
  createdAt?: string;
  updatedAt?: string;
}

export interface ChecklistTemplateFilters {
  serviceType?: string;
  isActive?: boolean;
  search?: string;
}

const checklistTemplateService = {
  // Criar um novo template de checklist
  createChecklistTemplate: async (data: Omit<ChecklistTemplate, '_id' | 'createdAt' | 'updatedAt' | 'createdBy'>) => {
    console.log('[ChecklistTemplate.createChecklistTemplate] Dados enviados:', JSON.stringify(data));
    
    // Verificar se há itens com valor definido
    if (data.items) {
      data.items.forEach((item, index) => {
        console.log(`[ChecklistTemplate.createChecklistTemplate] Item ${index}:`, {
          description: item.description,
          type: item.type,
          value: item.value,
          requireSignature: item.requireSignature,
          parentItemId: item.parentItemId || null
        });
      });
    }
    
    const response = await api.post('/checklist-templates', data);
    console.log('[ChecklistTemplate.createChecklistTemplate] Resposta do servidor:', response.data);
    return response.data;
  },

  // Obter todos os templates de checklist
  getChecklistTemplates: async (filters: ChecklistTemplateFilters = {}) => {
    const response = await api.get('/checklist-templates', { params: filters });
    return response.data;
  },

  // Obter um template de checklist por ID
  getChecklistTemplateById: async (id: string) => {
    const response = await api.get(`/checklist-templates/${id}`);
    return response.data;
  },

  // Atualizar um template de checklist
  updateChecklistTemplate: async (id: string, data: Partial<ChecklistTemplate>) => {
    console.log('[ChecklistTemplate.updateChecklistTemplate] Dados enviados:', JSON.stringify(data));
    
    // Verificar se há itens com valor definido
    if (data.items) {
      data.items.forEach((item, index) => {
        console.log(`[ChecklistTemplate.updateChecklistTemplate] Item ${index}:`, {
          description: item.description,
          type: item.type,
          value: item.value,
          requireSignature: item.requireSignature,
          parentItemId: item.parentItemId || null
        });
      });
    }
    
    const response = await api.put(`/checklist-templates/${id}`, data);
    console.log('[ChecklistTemplate.updateChecklistTemplate] Resposta do servidor:', response.data);
    return response.data;
  },

  // Excluir um template de checklist
  deleteChecklistTemplate: async (id: string) => {
    const response = await api.delete(`/checklist-templates/${id}`);
    return response.data;
  },

  // Obter templates de checklist por tipo de serviço
  getChecklistTemplatesByServiceType: async (serviceType: string) => {
    const response = await api.get(`/checklist-templates/service-type/${serviceType}`);
    return response.data;
  }
};

export default checklistTemplateService;
